<template>
  <div class="h-screen bg-gray-200 sys-app-notCollapsed font-sans flex min-h-screen w-full">
    <nav-bar class="w-64 p-4" />
    <router-view class="w-full p-4 overflow-x-hidden" />
  </div>
</template>

<script>
import { actionNames } from '../../store'
import NavBar from './NavBar'

export default {
  name: 'Dashboard',
  components: { NavBar },
  methods: {
    logout () {
      this.$store.dispatch(actionNames.LOGOUT)
    }
  }
}
</script>
